import React from "react";
import {
  Badge,
  Button,
  Card, CardBody, Col, DropdownItem, InputGroup, InputGroupAddon, Row, UncontrolledTooltip,  CustomInput , Input
} from "reactstrap";
import {observer} from "mobx-react-lite";
import {FormattedMessage, useIntl} from "react-intl";
import * as Icon from "react-feather";
import ScanbuyTable, {TableColumn} from "../../tables/ScanbuyTable";
import TableActionsDropdown from "../../tables/TableActionsDropdown";
import {useRouterStore} from "mobx-state-router";
import GenericModal from "../../elements/modal/GenericModal";
import dayjs from "dayjs";
import {createdByColumn} from "../../tables/TableColumns";
import {getSnapshot} from "mobx-state-tree";
import AdvancedConfFilterSelect from "../../elements/filters/AdvancedConfFilterSelect";
import {buildDimensionFilters} from "../../../utils/buildDimensionFilters";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDoubleDown, faAngleDoubleUp} from "@fortawesome/free-solid-svg-icons";

import {ADVANCED_SETTINGS_MANAGE_SET, formConstants} from "../../../utils/constants"
import GroupFilterSelect from "../../elements/filters/GroupFilterSelect";
import {requiredRolesCheck} from "../../../utils/requiredRolesCheck";
import DefaultSettingDeleteViewState from "../delete/DefaultSettingDeleteViewState";
import DefaultSettingDeleteView from "../delete/DefaultSettingDeleteView";
import FilterSelect from "../../elements/filters/FilterSelect";
import {buildColumnsWithOptionalSupport} from "../../../utils/optionalColumnsHelper";
import OptionalColumnsDropdown from "../../elements/dropdown/OptionalColumnsDropdown";

export const buildDefaultSettingsColumns = (routerStore,defaultSettingListViewState) => {

  const {rootStore} = routerStore.options;


  const c1 = TableColumn.create({name: 'Default Setting', property: 'defaultSetting', sortable: true, sortField: 'name'});
  c1.setSelector((row) =>{
    return(
      <>
        <span id={`tooltip-${row.uuid}`}>{row.name}</span>
        <UncontrolledTooltip target={`tooltip-${row.uuid}`} placement="top">{row.label}</UncontrolledTooltip>
      </>
    )})

  const actionColl = TableColumn.create({
    name: 'Actions', property: 'actions', button: true, allowOverflow: true, ignoreRowClick: true
  });
  const c2 = TableColumn.create({
    name: 'Groups', property: 'groups', hide: 'sm'
  });
  c2.setSelector((row) => {
    return row.groups;
  });
  c2.setCell((row) => {
    const groupsArray = defaultSettingListViewState?.groupSelectStore?.groupStore?.groups;
    let extractedGroups
    if (Array.isArray(groupsArray)) {
      extractedGroups = groupsArray.filter(group =>
        Array.isArray(row.groups) && row.groups.includes(group.uuid)
      );
    }
    const groups = extractedGroups.flatMap((t) => {
      return {uuid: t?.uuid, name: t?.name}
    });
    const displayedGroups = groups.length > 0 ? groups.slice(0, 2) : [];
    const remainingCount = groups.length - displayedGroups.length;
    return (<div>
      {displayedGroups.length > 0 ? (
        <>
          {displayedGroups.map((group, index) => (
          <Badge key={index} color="info" className="badge-pill mr-1 mb-1">
            {group.name}
          </Badge>
          ))}
          {remainingCount > 0 && (
            <Badge color="secondary" className="badge-pill mr-1 mb-1">
              +{remainingCount} more
            </Badge>
          )}
        </>

      ) : (
        <Badge color="info" className="badge-pill mr-1 mb-1">All</Badge>
      )}
    </div>)
  })
  const c5 = TableColumn.create({
    name: 'Code Experience', property: 'code experience', hide: 'sm'
  });
  c5.setSelector((row) => {
    return row.types;
  });
  c5.setCell((row) => {
    const types = row.types || [];
    const displayedTypes = types.length > 0 ? types.slice(0, 2) : [];
    const remainingCount = types.length - displayedTypes.length;
    return (
      <div>
        {displayedTypes.length > 0 ? (
          <>
            {displayedTypes.map((type, index) => (
              <Badge key={index} color="info" className="badge-pill mr-1 mb-1 text-capitalize">
                {type}
              </Badge>
            ))}
            {remainingCount > 0 && (
              <Badge color="secondary" className="badge-pill mr-1 mb-1">
                +{remainingCount} more
              </Badge>
            )}
          </>
        ) : (
          <Badge color="info" className="badge-pill mr-1 mb-1">All</Badge>
        )}
      </div>
    );
  })
  // const dimensionStore = rootStore?.rootUiStore?.dimensionSelectViewState?.store.dimensions || [];
  // const dimensionColumns = dimensionStore.map((store) => {
  //   const dimensionColumn = TableColumn.create({
  //     name: store?.name || store?.label,
  //     property: `store?.name`,
  //     hide: 'sm',
  //   })
  //   dimensionColumn.setSelector((row) => {
  //       const storeDimensions = row.dimensions?.filter(
  //         (dimension) => dimension.storeUuid === store.uuid
  //       ) || [];
  //
  //       return storeDimensions.map((dimension) => dimension.name).join(", ");
  //     })
  //   dimensionColumn.setCell((row) => {
  //     const storeDimensions = Array.isArray(store.values) && Array.isArray(row.dimensions[store.uuid])
  //       ? store.values.filter((currentDimension) =>
  //         row.dimensions[store.uuid].includes(currentDimension.uuid)
  //       )
  //       : [];
  //     return (
  //       <div>
  //         {storeDimensions.map((dimension, index) => (
  //           <Badge
  //             key={index}
  //             color="primary"
  //             className="badge-pill mr-1 mb-1"
  //           >
  //             {dimension.name}
  //           </Badge>
  //         ))}
  //       </div>
  //     );
  //   });
  //   return dimensionColumn;
  // });

  const dimensionStore = rootStore?.rootUiStore?.dimensionSelectViewState?.store.dimensions || [];

  const dimensionColumn = TableColumn.create({
    name: "Dimensions",
    property: "dimensions",
    hide: 'sm',
  });

  dimensionColumn.setSelector((row) => {
    const dimensionNames = dimensionStore
      .map((store) => {
        const storeDimensions = row.dimensions?.filter(
          (dimension) => dimension.storeUuid === store.uuid
        ) || [];
        return storeDimensions.map((dimension) => dimension.name);
      })
      .flat();

    return dimensionNames.length > 2
      ? `${dimensionNames.slice(0, 2).join(", ")} +${dimensionNames.length - 2} more`
      : dimensionNames.join(", ");
  });

  dimensionColumn.setCell((row) => {
    const allDimensions = dimensionStore.flatMap((store) => {
      return Array.isArray(store.values) && Array.isArray(row.dimensions[store.uuid])
        ? store.values.filter((currentDimension) =>
          row.dimensions[store.uuid].includes(currentDimension.uuid)
        )
        : [];
    });

    const displayedDimensions = allDimensions.slice(0, 2);
    const remainingCount = allDimensions.length - displayedDimensions.length;

    return (
      <div>
        {
          displayedDimensions.length > 0 ? (
          <>
            {displayedDimensions.map((dimension, index) => (
            <Badge key={index} color="primary" className="badge-pill mr-1 mb-1">
              {dimension.name}
            </Badge>
          ))}
            {remainingCount > 0 && (
              <Badge color="secondary" className="badge-pill mr-1 mb-1">
                +{remainingCount} more
              </Badge>
            )}
          </>
          ):(
            <Badge color="primary" className="badge-pill mr-1 mb-1">
              All
            </Badge>
          )
        }
      </div>
    );
  });

  const dimensionColumns = [dimensionColumn];


  const c3 = TableColumn.create({
    name: 'Create Date', property: 'created', width: '15%', hide: 'sm',sortable: true, sortField: 'createdAt',
  });
  c3.setSelector((row) => {
    const {createdAt} = row || {};
    const formattedCreateDate = dayjs(createdAt).format('YYYY-MM-DD HH:mm:ss');
    return formattedCreateDate;
  });

  const c4 = TableColumn.create({
    name: 'Last Modified', property: 'updated', width: '15%', hide: 'sm', sortable: true, sortField: 'updatedAt',
  });
  c4.setSelector((row) => {
    const { updatedAt } = row || {};
    const formattedUpdateDate = dayjs(updatedAt).format('YYYY-MM-DD HH:mm:ss');
    return formattedUpdateDate;
  });

  const createdBy = createdByColumn();


  actionColl.setCell((row) => (
    <TableActionsDropdown actionsList={[
      // <DropdownItem id="action-btn-view" key={'/configs/utms/view/' + row.uuid} onClick={() => {
      //   routerStore.goTo('editUtm', {
      //     params: { uuid: row.uuid },
      //     queryParams: {isEditable: 'false'}
      //   });
      // }}><Icon.FileText/>&nbsp;View</DropdownItem>,
      // ...(row.isEditable ? [
        [<DropdownItem id="action-btn-edit" key={'/default-settings/edit/' + row.uuid} onClick={() => {
          routerStore.goTo('editDefaultSetting', {
            params: { uuid: row.uuid },
          });
        }}><Icon.Edit/>&nbsp;Edit</DropdownItem>],
    // ]: []),
    //   ...(row.isEditable ?
      //   [
        [<DropdownItem id="action-btn-delete" key={row.uuid} value={"Delete " + row.uuid} className="align-text-bottom"
                      onClick={() => {

                        // const userRoles = rootStore?.userRoles
                        // if(!requiredRolesCheck(ADVANCED_SETTINGS_MANAGE_SET, userRoles)) return

                        const componentStore = DefaultSettingDeleteViewState.create(
                          {
                            defaultSettingName: row.name,
                            title: `Delete ${row.name ? row.name : ""}`,
                            uuid: row.uuid
                          });
                        rootStore.rootUiStore.attachPageState('defaultSettingDeleteViewState', componentStore)

                        componentStore.setToggleListener(defaultSettingListViewState.modalStore.toggle)
                        componentStore.setRefreshListener(defaultSettingListViewState.refresh)
                        defaultSettingListViewState.handleRowClick(row, componentStore, DefaultSettingDeleteView);
                      }}> <Icon.Delete/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.delete.defaultMessage"/>
        </DropdownItem>]
      //     : [])

    ]}/>
  ))
  const allColumns = [

    c1,
    c2,
    ...dimensionColumns,
    c5,
    c3,
    createdBy,
    c4,
    actionColl,
  ];

  return buildColumnsWithOptionalSupport(allColumns, defaultSettingListViewState, rootStore);
}

const DefaultSettingListView = observer(({defaultSettingListViewState}) => {
    const routerStore = useRouterStore();
    const intl = useIntl();
    //TODO: PATTERN VIOLATION - setOnSelectChanges called on every render
    // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
    defaultSettingListViewState.setOnSelectChanges()
    //TODO: PATTERN VIOLATION - Multiple filter setters called on every render (lines 295-299)
    // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
    defaultSettingListViewState.listModel.items.setFilterOn(defaultSettingListViewState.groupSelectStore?.selectedGroup?.uuid)
    defaultSettingListViewState?.advFilterSelectState?.setEmails(defaultSettingListViewState.listModel?.filters?.users);
    defaultSettingListViewState?.advFilterSelectState?.setExperience(defaultSettingListViewState.listModel?.filters?.types);
    defaultSettingListViewState?.filterGroup && defaultSettingListViewState?.groupFilterSelectState?.setGroups(defaultSettingListViewState.listModel?.filters?.groups);
    defaultSettingListViewState?.dimensionSelectViewState?.setFilteredDimensions(defaultSettingListViewState?.listModel?.filters.dimensions);

    const customStyles = {
      headRow: {
        style: {
          border: 'none',
        },
      },
      headCells: {
        style: {
          color: '#202124',
          fontSize: '14px',
        },
      },
      rows: {
        highlightOnHoverStyle: {
          backgroundColor: 'rgb(230, 244, 244)',
          borderBottomColor: '#FFFFFF',
          outline: '1px solid #FFFFFF',
        },
      },
      pagination: {
        style: {
          border: 'none',
        },
      },
    }

    return (
      <>
        <Card>
          <CardBody>
            <Row>
              <Col className="text-right">
                {defaultSettingListViewState.isFilterVisible ? <Button id="defaultSettinglist-dropdown-open" color="primary" onClick={()=> {defaultSettingListViewState.toggleFilterVisible()}}><FontAwesomeIcon icon={faAngleDoubleUp} /></Button>
                  : <Button id="defaultSettinglist-dropdown-closed" color="primary" onClick={()=> {defaultSettingListViewState.toggleFilterVisible()}}><FontAwesomeIcon icon={faAngleDoubleDown} /></Button>}
              </Col>
              <OptionalColumnsDropdown
                listViewState={defaultSettingListViewState}
                buildColumnsFunction={buildDefaultSettingsColumns}
                idPrefix="default-setting-col"
              />
            </Row>
            {defaultSettingListViewState.isFilterVisible && <>
              <Row>
                <Col sm={5}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      {intl.formatMessage({id: "filterByGroups.defaultMessage"})}
                    </InputGroupAddon>
                    <GroupFilterSelect groupFilterSelectState={defaultSettingListViewState.groupFilterSelectState}/>
                  </InputGroup>
                </Col>
                <Col sm={5}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      {intl.formatMessage({id: "listCodes.filter.filterName.defaultMessage"})}
                    </InputGroupAddon>
                    <FilterSelect advFilterSelectState={defaultSettingListViewState.advFilterSelectState}/>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                {defaultSettingListViewState?.dimensionSelectViewState?.dimensionsEnabled && defaultSettingListViewState?.dimensionSelectViewState?.dimensionSelectStates?.map(dimensionSelectStore => buildDimensionFilters(dimensionSelectStore))}
              </Row>
              <Row>
                <Col sm={5}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      {intl.formatMessage({id: "listCodes.searchInput.defaultMessage"})}
                    </InputGroupAddon>
                    <Input
                      type="text"
                      name="searchInput"
                      placeholder="Search"
                      onChange={defaultSettingListViewState.onSearchChange}
                    />
                  </InputGroup>
                </Col>
                <Col sm={5}></Col>
                <Col sm= {2} className="justify-content-end text-right" >
                  <Button id="create-defaultSetting-btn" color="primary" onClick={() => {
                    routerStore.goTo('createDefaultSetting', {});
                  }}>
                    <FormattedMessage id="qrDesign.manageList.create.defaultMessage"/>
                  </Button>
                </Col>
              </Row>
            </>}
            <Row>
              <Col>
                {defaultSettingListViewState.listModel.items.defaultSettings.length ?
                  <ScanbuyTable
                    key={defaultSettingListViewState?.columns.length}
                    columns={defaultSettingListViewState.columns}
                    customStyles={customStyles}
                    store={defaultSettingListViewState.listModel}
                  />
                  :
                  <ScanbuyTable
                    key={defaultSettingListViewState?.columns.length}
                    columns={defaultSettingListViewState.columns}
                    customStyles={customStyles}
                    store={defaultSettingListViewState.listModel}
                  />
                }
              </Col>
            </Row>
          </CardBody>
        </Card>
        <GenericModal
          modalStore={defaultSettingListViewState.modalStore}
          componentStore={defaultSettingListViewState.modalComponentStore}
          EmbedComponent={defaultSettingListViewState.modalComponent}
        />
      </>
    )
  }
)

export default DefaultSettingListView
